import TpRadioBase from './tp-radio-base.js';

class TpRadio extends TpRadioBase { }
export default TpRadio;